import { useEffect, useState } from "react";
import ParkingApi from "../../api/parking";

import useCallApi from "../../hooks/useCallApi";
import { useRTL } from "../../hooks/useLanguage/useRTL";

type ITitle = {
  value: string;
  language: "en" | "ar";
};

type ILevel = {
  id: string;
  title: ITitle[];
  visitor?: {
    capacity: number;
    available: number;
  };
  tenant?: {
    capacity: number;
    available: number;
  };
  ev?: {
    capacity: number;
    available: number;
  };
};

type IParkingZone = {
  id: string;
  title: ITitle[];
  designator: string;
  types: {
    id:
      | "TENANT_PARKING"
      | "TENANT_VALET_PARKING"
      | "TENANT_EV_PARKING"
      | "VISITOR_PARKING"
      | "VISITOR_VALET_PARKING"
      | "VISITOR_EV_PARKING"
      | "TENANT_VISITOR_PARKING"
      | "TENANT_VALET_VISITOR_PARKING"
      | "TENANT_VISITOR_EV_PARKING"
      | "TENANT_VALET_VISITOR_EV_PARKING";
    title: ITitle[];
    levels: ILevel["id"][];
  }[];
  levels: ILevel[];
  coordinates: {
    lat: number;
    lng: number;
  };
  isConstructed: boolean;
};

type IParkingArea = {
  id: string;
  title: ITitle[];
  zones: IParkingZone[];
};

const useParkingContainer = () => {
  const { callApi, loading } = useCallApi();
  const { isRTL } = useRTL();

  const [pageLoading, setPageLoading] = useState(true);

  const [allParking, setAllParking] = useState<IParkingArea[]>([]);

  const [page, setPage] = useState(1);

  const handleChangePage = (
    parking: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(
      ParkingApi.getAll(),
      ({ parkings }: { parkings: IParkingArea[] }) => {
        setAllParking(parkings);
        setPageLoading(false);
      }
    );
  }, [isRTL]);

  return {
    parkings: allParking,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage: 6,
    loading,
  };
};

export default useParkingContainer;
